"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadQRCodeWithLogo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const CTAFooter_1 = require("../CTAFooter");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const urls_1 = require("../../utils/urls");
const react_qrcode_logo_1 = require("react-qrcode-logo");
const DownloadQrCodeWithLogo_module_css_1 = __importDefault(require("./DownloadQrCodeWithLogo.module.css"));
/**
 * used for generating QR code for downloading snapchat
 */
function DownloadQRCodeWithLogo(props) {
    const qrCodeValue = (0, react_1.useMemo)(() => {
        const pageTypeName = web_blizzard_reporting_1.PageType[props.pageType].toLowerCase();
        const iosAppStoreUrl = (0, urls_1.toAppStoreUrl)(pageTypeName);
        const webPageUrl = (0, urls_1.toWebDownloadPageUrl)(pageTypeName);
        const oneLinkParams = (0, CTAFooter_1.consumerWebOneLinkParams)(pageTypeName, urls_1.UNLOCK_DEEPLINK_URL, iosAppStoreUrl, webPageUrl);
        // we should never use this - but deeplink or open the download page in the off-chance
        const fallbackURL = `https://link.snapchat.com/download?web_client_id=${props.wcid}&trace_id=${props.traceId}`;
        return (0, CTAFooter_1.tryGenerateOneLinkOrDefault)({
            oneLinkParams,
            webClientId: props.wcid,
            webPageViewTraceId: props.traceId,
            fallbackUrl: fallbackURL,
            config: {
                disableWebAfDp: true,
            },
            pageType: props.pageType,
        });
    }, [props.pageType, props.wcid, props.traceId]);
    const logoUrl = props.logoUrl ?? "https://static.snapchat.com/images/ghost-icon-filled.png";
    const commonQRCodeProps = {
        ecLevel: "L",
        size: 225,
        bgColor: props.backgroundColor,
        logoImage: logoUrl,
        logoPadding: 5,
        logoPaddingStyle: "circle",
        value: qrCodeValue,
    };
    if (!props.useNewDesign) {
        return (0, jsx_runtime_1.jsx)(react_qrcode_logo_1.QRCode, { ...commonQRCodeProps });
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: DownloadQrCodeWithLogo_module_css_1.default.qrWrapper, children: (0, jsx_runtime_1.jsx)(react_qrcode_logo_1.QRCode, { ...commonQRCodeProps, size: 200, logoPadding: 7, qrStyle: "dots" }) }));
}
exports.DownloadQRCodeWithLogo = DownloadQRCodeWithLogo;
//# sourceMappingURL=DownloadQrCodeWithLogo.js.map